import { useEffect } from 'react';

const LOOKUP_MS = 250;
const GIVE_UP_MS = 6000;

// Abas (.category-tab) e itens do menu de seções da ficha (ModuleNav, [data-section])
const TAB_SELECTOR = '.category-tab, nav [data-section]';
const isOpen = (tab) => tab.classList.contains('active') || tab.getAttribute('aria-current') === 'true';

/**
 * Passo do showcase com openTab (tourScripts.js): ao chegar na tela, abre uma vez a
 * aba ou seção com esse rótulo, assim que ela aparece. Se a pessoa trocar de
 * aba depois, o guia não insiste. Aba travada (sem permissão) a própria tela recusa.
 */
export default function useShowcaseTab(step, pathname) {
  const label = step && step.openTab ? step.openTab : null;

  useEffect(() => {
    if (!label) return undefined;
    const started = Date.now();
    let timer = null;
    const tryOpen = () => {
      const tab = Array.from(document.querySelectorAll(TAB_SELECTOR))
        .find((button) => button.textContent.trim() === label);
      if (tab) {
        if (!isOpen(tab)) tab.click();
        clearInterval(timer);
        return;
      }
      if (Date.now() - started > GIVE_UP_MS) clearInterval(timer);
    };
    timer = setInterval(tryOpen, LOOKUP_MS);
    tryOpen();
    return () => clearInterval(timer);
  }, [label, step, pathname]);
}
